module.exports = __webpack_public_path__ + "img/edicion.f097bcb2.png";